import React, { useState } from 'react';
import Switch from 'react-bootstrap-switch';
import moment from 'moment';
import { Link } from 'react-router-dom'

import Loader from '../../common/components/notifications/Loader';

const ImportRow = props => {
    const [details, setDetails] = useState(false)

    const toggleDetails = () => setDetails(prev => !prev)

    const renderCreatingEvent = (event) => {
        return (
            <div className="importer-event clearfix">
                <div className="row">
                    <div className="col-md-12">
                        <Loader message="Creating Event"/>
                    </div>
                </div>
            </div>
        );
    }

    const renderSuccessfulImport = (event) => {
        return (
            <div className="importer-event clearfix bg-success-lt">
                <div className="row">
                    <div className="col-md-12">
                        <div className="col-md-8">
                            <h4>
                                {event.title}
                            </h4>
                            <p><span className="formatting monospace">{event.eventID}</span></p>
                            <p>
                                {event.description ? event.description : ''}
                            </p>
                        </div>

                        <div className="col-md-4 text-right">
                            <Link to={'/events/?eventID=' + event.eventID}
                                className="btn btn-default"
                                target="_blank">
                                Go To Event <i className="fa fa-arrow-right"/>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    
    const renderFailedImport = (event) => {
        return (
            <div className="importer-event clearfix bg-danger-lt">
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            {event.title}
                        </h4>
                        <p>
                            <strong>Failed to create Event</strong>
                            <ul>
                                {event.errorMessages.map(function (msg) {
                                    return <li>{msg}</li>;
                                })}
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    var {
        index,
        event,
        categoryNames,
        renderedCategories,
        handleAssign,
        handleCategoryAssign
    } = props;

    var formattedDate = event.startDateTime;
    try {
        formattedDate = moment(
            event.startDateTime,
            'YYYY-MM-DD HH:mm:ss'
        ).format('MM/DD/YYYY, hh:mm:ss a');
    } catch (e) {
        formattedDate = "INVALID DATE PROVIDED";
        console.warn(e);
    }

    if (event.createStatus != 'pending') {
        if (event.createStatus == 'success') {
            return renderSuccessfulImport(event);
        } else if (event.createStatus == 'creating') {
            return renderCreatingEvent(event);
        } else if (event.createStatus == 'fail') {
            return renderFailedImport(event);
        }
    }

    var categoryName = ""
    if (props.categoryMap[index]) {
        categoryName = props.categoryMap[index]
    } else if (categoryNames.indexOf(event.category) >= 0) {
        categoryName = event.category
    }

    const renderDetails = () => {
        if (details) {
            var {
                index,
                event,
                encoders,
                locations,
                handleEncoderAssign,
                handleEstRuntimeChange,
                handleBreakOverrideChange,
                handleBreakOnStartChange,
                handleLocationAssign
            } = props;

            var encoderSelect = (<div className="col-sm-12 form-group">
                    <label>Encoder</label>
                        <select className="form-control"
                            onChange={handleEncoderAssign.bind(null, index)}
                            defaultValue={props.encoderMap[index] ||
                                event.encoder || ""}
                            name="encoderID">
                                <option value="" disabled>Select Encoder &hellip;</option>
                                {encoders}
                        </select>
            </div>);


            const estimatedRuntime = (<div className="col-md-12 form-group">
                    <label>Estimated Runtime</label>

                        <div className='validation-wrapper'>
                            <div className="input-group">
                                <span className="input-group-addon"><i className="far fa-clock"/></span>
                               
                                <input 
                                type="text" 
                                placeholder="hh:mm" 
                                className="form-control"
                                maxLength={5} 
                                name="estRuntime"
                                onChange={(e) => {
                                    const validationWrapperClassList = e.target.closest(".validation-wrapper").classList;
                                    const value = e.target.value;
                                    const numOnlyRegex = /[^0-9]/g;

                                    let customValue = value;
                                    
                                    validationWrapperClassList.remove("valid")
                                    validationWrapperClassList.add("invalid")

                                    // don't allow colons except in the 2nd index
                                    if (value.includes(":")) {
                                        if(value.lastIndexOf(":") != 2) {
                                            return
                                        }
                                    }
                                    
                                    // adding the colon at index 2
                                    if (value.length == 2) {
                                        customValue += ":";
                                    }

                                    let inputArray = customValue.split(':');

                                    if (Number(inputArray[0]) > 24) {
                                      inputArray[0] = "24";
                                    } else if (inputArray[0] && inputArray[0].match(numOnlyRegex)) return;

                                    if (Number(inputArray[1]) > 59) {
                                      inputArray[1] = "59";
                                    } else if (inputArray[1] && inputArray[1].match(numOnlyRegex)) return;

                                    if (Number(inputArray[0]) == 24 && inputArray[1]) {
                                        inputArray[1] = "00";   
                                    }

                                    if (inputArray[0] === "00" && inputArray[1] === "00") {
                                        inputArray[0] = "01";
                                        inputArray[1] = "00";
                                    }

                                    const HAMString = inputArray.join(':');

                                    handleEstRuntimeChange(index, HAMString)
                                    
                                    if (HAMString.length == 5) {
                                        validationWrapperClassList.remove("invalid")
                                        validationWrapperClassList.add("valid")
                                    }                                    
                                  }} 

                                onKeyDown={(e) => {
                                    const validationWrapperClassList = e.target.closest(".validation-wrapper").classList;
                                    if(e.target.value.length == 1) {
                                        validationWrapperClassList.remove("invalid")
                                        validationWrapperClassList.add("valid")
                                    }
                                    if (e.key == 'Backspace') {
                                        handleEstRuntimeChange(index, e.target.value.slice(0, -1));
                                    }
                                }}

                                onBlur={(e) => {
                                    if (e.target.value.length === 5) return;

                                    let editedValue = e.target.value;
                                    const validationWrapperClassList = e.target.closest(".validation-wrapper").classList;

                                    switch (editedValue.length) {
                                        case 0:
                                            editedValue = "01:00"
                                            break;
                                        case 1:
                                            editedValue = "0" + editedValue + ":00"
                                            break;
                                        case 3:
                                            editedValue += "00"
                                            break;
                                        case 4:
                                            editedValue += "0"
                                            break;
                                        default:
                                            break;
                                    }

                                    if(editedValue === "00:00") {
                                        editedValue = "01:00"
                                    }

                                    validationWrapperClassList.remove("invalid")
                                    validationWrapperClassList.add("valid")

                                    handleEstRuntimeChange(index, editedValue);
                                }}

                                value={event.estRuntime || ""} />
                            </div>
                        </div>
            </div>);

            const liveToBreakSwitch = (<div className="col-sm-6 form-group" style={{display: "flex", flexDirection: "column"}}>
                    <label>Go To Break On Start</label>
                        <Switch
                            defaultValue={false}
                            name="liveToBreak"
                            onChange={(e, newValue) => handleBreakOnStartChange(index, newValue ? "TRUE" : "FALSE")}
                            value={event.liveToBreak === "TRUE" ? true : false}
                            />
                </div>);

            const breakOverrideSwitch = (<div className="col-sm-6 form-group" style={{display: "flex", flexDirection: "column"}}>
                    <label>Break Override</label>
                        <Switch
                            defaultValue={false}
                            name="breakOverride"
                            onChange={(e, newValue) => handleBreakOverrideChange(index, newValue ? "TRUE" : "FALSE")}
                            value={event.breakOverride == "TRUE" ? true : false}
                            />
            </div>);

            var locationSelect = (<div className="col-sm-12 form-group">
                    <label>Location</label>

                    <select className="form-control"
                        onChange={handleLocationAssign.bind(null, index)}
                        defaultValue={props.locationMap[index] || event.location || ""}
                        name="locationID">
                            <option value="" disabled>Select Location &hellip;</option>
                            {locations}
                    </select>
            </div>);

            var customID = (event.customID != '') ? <code>{event.customID}</code> : <em>Not provided</em>;
            var description = (event.description != '') ? event.description : <em>Not provided</em>;

            return (
                <div className="callout clearfix" style={{margin: '1em'}}>
                    <div className="col-md-6">
                        <label>Custom ID:</label>&nbsp;<span>{customID}</span>
                        <div className="clearfix" />
                        <label>Description:</label>
                        <p>{description}</p>
                    </div>
                    <div className="col-md-6">
                        {encoderSelect}
                        <hr/>
                        {locationSelect}
                        <hr/>
                        {estimatedRuntime}
                        <hr/>
                        {liveToBreakSwitch} 
                        {breakOverrideSwitch}
                    </div>
                </div>
            );
        }
    }

    const renderEncoderWithSelected = () => {
        var opts = props.encoders.data.map(function (encoder) {
            return (
                <option key={'encoder-' + encoder.encoderID} value={encoder.encoderID}>
                    {encoder.simpleName} - ({encoder.online ? 'Online' : 'Offline'})
                </option>
            );
        });
        return opts;
    }

    return (
        <div className={'importer-event clearfix'}>
            <div className="row">
                <div className="col-md-12">
                    <div className="col-md-2">
                        <Switch
                            animate={false}
                            value={event.assigned}
                            onText="Import"
                            offText="Omit"
                            size="small"
                            onChange={handleAssign.bind(null, index)}/>
                    </div>
                    <div className="col-md-4">
                        <h4>{event.title}</h4>
                        <span className="badge">{event.private ? "Private" : "Public"}</span> <small>{formattedDate}</small>
                    </div>
                    <div className="col-md-4">
                        <div className="form-horizontal">
                            <div className="form-group">
                                <label className="col-sm-2 control-label">Category</label>
                                <div className="col-sm-10">
                                    <select className="form-control"
                                        onChange={handleCategoryAssign.bind(null, index)}
                                        value={categoryName}
                                        name="categoryID">
                                            <option value="" disabled>Select one &hellip;</option>
                                            {renderedCategories}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 text-right">
                        <button className="btn btn-default" onClick={toggleDetails}>
                            {details ?
                                <i className="fa fa-caret-up"/> : <i className="fa fa-caret-down"/>}
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                {renderDetails()}
            </div>
        </div>
    );

}

export default ImportRow;
